'use client'
import { PlusIcon } from '@heroicons/react/24/solid'
import { Button } from '@/frontend/design-system/actions/Button'

export function AddNewCourseCategoryButton({
  canManageCourseCategories
}: {
  canManageCourseCategories: boolean
}) {
  return (
    canManageCourseCategories && (
      <Button marketing href='/kursy/course-category/upsert' className='w-fit'>
        <PlusIcon />
        Dodaj nową kategorię kursu
      </Button>
    )
  )
}
